export const projectSettingsCallbacksColumnsWidth = {
  createdAt: 130,
  updatedAt: 130,
};
